import { ENDPOINT } from '~/api/constants';
import { RequestAPI } from '~/api/Requests';
import type { PromocodeType } from '~/entities/Promocode';
import { PromocodesTab } from '~/stores/PromotionsStore';

interface PromocodesRequests {
  getPromocodes(
    customerId: string,
    tab: PromocodesTab,
    data: { pagination: { size: number; current: number } },
  ): Promise<GetPromocodesResponse>;
}

interface GetPromocodesResponse {
  data: IPromocode[];
  pagination: {
    total: number;
    current: number;
    size: number;
  };
}

export interface IAllowedCategoriesData {
  id: number;
  name: string;
  slug: string;
}

export interface IPromocodeOrder {
  id: number;
  orderId: string;
  promocodeId: number;
  createdAt: string;
}

export interface IPromocode {
  id: number;
  type: PromocodeType;
  code: string;
  value: number;
  minimumPurchase: number;
  minimumQuantity: number;
  usageLimitCustomer: number;
  usageCurrent: number;
  usageLimitAll: number;
  dateRange: [string, string];
  orderNumberRange: [number, number];
  isActive: boolean;
  createdAt: string;
  deletedAt: string | null;
  customerId: string;
  usageCurrentCustomer: number;
  allowedCategoriesData: IAllowedCategoriesData[];
  orders: IPromocodeOrder[];
}

export const PromocodesRequests: PromocodesRequests = {
  getPromocodes: (customerId, tab, data) => {
    const endpoint =
      tab === PromocodesTab.AVAILABLE
        ? ''
        : tab === PromocodesTab.USED
          ? '/history'
          : '/inactive';

    return RequestAPI.get(
      ENDPOINT.promocodes.getPromocodes.replace('{customerId}', customerId) +
        endpoint,
      data,
    );
  },
};
